import React from 'react';
import { withStyles } from '@material-ui/core/styles';


//drop down field
import MenuItem from 'material-ui/MenuItem';
import { ValidatorForm,SelectValidator } from 'react-material-ui-form-validator';
import Button from '@material-ui/core/Button';

//API Gateway
import {API} from "aws-amplify";

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 500,
  },
});

class CountrySelect extends React.Component {
  state = {
    countries:[],
    country:''

  };

    //Make GET request to get the list of country, 
    async componentDidMount() {
  
        try {

          const countries =await this.getCountry();
          this.setState({ countries });

        } catch (e) {
          alert(e);
        }
      
        this.setState({ submitted: false });
      }
     // make call to API to get country for dropdown list

      getCountry() {
        return API.get("country", "/country");
      }

  // COUNTRY Dropdown Menu change
  handleCountryFieldChange = (event, index, country) => 
  {
      this.setState({country});
      var countryName = country;

      this.props.onChange(countryName);
  }

  selectionRenderer = (countries) => {
    switch (countries.length) {
      case 0:
        return '';
      case 1:
        return countries;
      default:
        return countries;
    }
  }

  menuItems(countries) {
    return countries.map((l) => (
      <MenuItem
        key={l.country}
        insetChildren={true}
        checked={this.state.countries.indexOf(l.country) > -1}
        value={l.country}
        primaryText={l.country}
      />
    ));
  }

  reset(event) {

    this.setState({  
      country:''
  });

  this.props.onChange('','');  

  };
  render() {

    return (
      <div>

        <ValidatorForm
                ref="form"
                onSubmit={this.handleCountryFieldChange}

            >            
             <SelectValidator
                  floatingLabelText="Country"
                  name= "country"
                  autoWidth={true}
                  value={this.state.country}
                  onChange={this.handleCountryFieldChange}
                  selectionRenderer={this.selectionRenderer}
                  
                >
                  {this.menuItems(this.state.countries.sort((a, b) => (a.country < b.country ? -1 : 1)))}
                </SelectValidator>
                <Button size="small" color="primary" onClick={ this.reset.bind(this)} style={{marginLeft:10, marginBottom:20}}>
                    Reset
                  </Button>
        </ValidatorForm>
      </div>
    );
  }
}



export default withStyles(styles)(CountrySelect);